import { useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Link, useNavigate } from "react-router-dom";

import { Title, Form } from "./styles";
import { IConfirmInvivation } from "../../interfaces";
import { LayoutAuth } from "../../../../components/LayoutAuth";
import { useNotification } from "../../../../hooks/useNotification";
import { confirmInvivation } from "../../../../services/collaborators";
import { useAuth } from "../../../../hooks/useAuth";
import { useTranslate } from "../../../../hooks/useTranslate";
import { Button, Stack } from "@mui/material";
import { DatePickerElement, TextFieldElement } from "react-hook-form-mui";
import { format, isValid } from "date-fns";

const ConfirmInvivation = () => {
  const { successNotification, errorNotification } = useNotification();
  const { setIdUserCollaborator } = useAuth();
  const { translate } = useTranslate();
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(false);

  const schema = yup.object({
    code: yup.string().required(translate("global.code_required")),
    dob: yup
      .date()
      .transform((v) => (isValid(v) ? v : null))
      .nullable()
      .required(translate("global.dob_required")),
  });

  const form = useForm<IConfirmInvivation>({
    resolver: yupResolver(schema),
  });

  const submitForm = async ({ code, dob }: IConfirmInvivation) => {
    setIsLoading(true);

    try {
      const collaborator = await confirmInvivation({
        code,
        dob: format(dob, "yyyy-MM-dd"),
      });
      setIdUserCollaborator(collaborator.id);
      setIsLoading(false);
      successNotification(translate("auth.success_invitation"));
      navigate("/signup");
    } catch {
      errorNotification(translate("auth.error_invivation"));
      setIsLoading(false);
    }
  };

  return (
    <LayoutAuth>
      <Title>{translate("auth.title_confirm_invivation")}</Title>
      <FormProvider {...form}>
        <Form onSubmit={form.handleSubmit(submitForm)}>
          <Stack spacing={1}>
            <TextFieldElement
              name="code"
              label={translate("global.placeholder_code_invite")}
            />
            <DatePickerElement
              name="dob"
              label={translate("global.placeholder_dob")}
            />
          </Stack>
          <Link to="/">{translate("auth.link_without_invivation")}</Link>
          <Button
            fullWidth
            color="secondary"
            variant="contained"
            type="submit"
            disabled={isLoading}
            sx={{ textTransform: "uppercase" }}
          >
            {translate("auth.btn_confirm_invivation")}
          </Button>
        </Form>
      </FormProvider>
    </LayoutAuth>
  );
};

export { ConfirmInvivation };
